import { render } from "./MainForm.vue?vue&type=template&id=f4dd731c&scoped=true"
import script from "./MainForm.vue?vue&type=script&lang=js"
export * from "./MainForm.vue?vue&type=script&lang=js"

import "./MainForm.vue?vue&type=style&index=0&id=f4dd731c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4dd731c"]])

export default __exports__